import React from 'react';

function Footer() {
  return (
    <footer className="border-t bg-green-600">
      <div className="mx-auto max-w-6xl px-4 py-3 text-sm text-white flex justify-end">
        <span>copyright by dsd</span>
      </div>
    </footer>
  );
}

export default Footer;


